import { createSlice } from '@reduxjs/toolkit';

const getInitialAuthState = () => {
    if (typeof window !== 'undefined') {
        const token = localStorage.getItem('token');
        return {
            token: token,
            user: null,
            isAuthenticated: !!token,
        };
    }
    return {
        token: null,
        user: null,
        isAuthenticated: false,
    };
};

const authSlice = createSlice({
    name: 'auth',
    initialState: getInitialAuthState(),
    reducers: {
        setCredentials: (state, action) => {
            const { token, user, refreshToken } = action.payload;
            state.token = token;
            state.user = user;
            state.isAuthenticated = true;
            if (typeof window !== 'undefined') {
                localStorage.setItem('token', token);
                if (refreshToken) {
                    localStorage.setItem('refreshToken', refreshToken);
                }
            }
        },
        updateUser: (state, action) => {
            state.user = { ...state.user, ...action.payload };
        },
        logout: (state) => {
            state.token = null;
            state.user = null;
            state.isAuthenticated = false;
            if (typeof window !== 'undefined') {
                localStorage.removeItem('token');
                localStorage.removeItem('refreshToken');
            }
        },
    },
});

export const { setCredentials, logout, updateUser } = authSlice.actions;
export default authSlice.reducer;
